<template>
  <div v-if="os.isQQMusic">
    <qqMusic ref="qqMusic" @updataState="updataState" @updataCurrId="updataCurrId" @initPlayer="initPlayer"></qqMusic>
  </div>
  <div v-else-if="os.isKuGouMusic">
    <kugouMusic ref="kugouMusic" @updataState="updataState" />
  </div>
  <div v-else-if="os.isKuwoMusic">
    <kuwoMusic ref="kuwoMusic" @updataState="updataState" />
  </div>
  <div v-else>
    <browserMusic ref="browserMusic" @updataState="updataState" @initPlayer="initPlayer" />
  </div>
</template>

<script>
  import os, { plantForm } from './util'
  export default {
    components: {
       qqMusic: () => import('./qqMusic/index.vue'),
       kugouMusic: () => import('./kuGouMusic/index.vue'),
       kuwoMusic: () => import('./kuWoMusic/index.vue'),
       browserMusic: () => import('./browserMusic/index.vue')
    },
    name: '',
    data() {
      return {
        os,
      }
    },
    methods: {
      updataState(state) {
        this.$emit('updataState', state)
      },
      initPlayer(player) {
        this.$emit('initPlayer', player)
      },
      updataCurrId(currId) {
        this.$emit('updataCurrId', currId)
      }
    }
  }
</script>

<style lang="less" scoped>
  
</style>